import React from 'react';

import Auth from '@src/auth/auth';
import Routes from '@src/app-routes';

import { useAppSelector } from '@store/hooks';

import { IUserSession } from '@src/entities/user-session';

import '@core/index.css';

declare global {
    interface Window {
        accessToken: string;
    }
}

const appVersion = process.env.REACT_APP_VERSION;

const App = () => {
    const userSession = useAppSelector<IUserSession>((s) => s.userSession);

    return userSession ? <Routes userSession={userSession} appVersion={appVersion} /> : <Auth appVersion={appVersion} />;
};

export default App;
